import useGetColorInitialValues from './useGetColorInitialValues'

export default useGetColorInitialValues
